import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Textarea Component
 * Apple-inspired multiline text input with refined states
 * Follows design tokens from tokens.css
 */
const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    (<textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-lg border border-app-border bg-app-surface px-3.5 py-2.5 text-sm text-app-text transition-all duration-base resize-y",
        "placeholder:text-app-text-tertiary",
        "hover:border-app-border-hover",
        "focus:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-app-focus focus-visible:border-app-focus",
        "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-app-secondary",
        className
      )}
      ref={ref}
      {...props} />)
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
